import { useEffect } from "react";

import {
  selectIsBookConversion,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { NEW_POLICY_SUBMIT_BUTTON_ID } from "@consts/index";

export const useScrollToNextButton = (isValid: boolean) => {
  const isBookConversion = useNewBusinessSelector(selectIsBookConversion);

  useEffect(() => {
    if (!isValid || !isBookConversion) return;

    // Small delay to ensure validation is finished
    const timer = setTimeout(() => {
      const nextButtonEl = document.getElementById(NEW_POLICY_SUBMIT_BUTTON_ID);
      if (nextButtonEl) {
        nextButtonEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 50);

    return () => clearTimeout(timer);
  }, [isValid, isBookConversion]);
};
